window.addEventListener('load', function () {
    const accordions = document.querySelectorAll('.wp-block-brblocks-accordion');

    accordions.forEach((accordion) => {
        const title = accordion.querySelector('.accordion-title');
        const content = accordion.querySelector('.accordion-content');
        const anchor = title ? title.id : content.id;

        // Function to open the accordion if the URL contains the anchor
        const openAccordion = () => {
            if (window.location.hash === `#${anchor}`) {
                // Close all other accordions
                accordions.forEach((acc) => {
                    if (acc !== accordion) {
                        acc.querySelector('.accordion-content').classList.remove('open');
                        const accTitle = acc.querySelector('.accordion-title');
                        if (accTitle) {
                            accTitle.classList.remove('active');
                        }
                    }
                });
                // Open the current accordion
                content.classList.add('open');
                if (title) {
                    title.classList.add('active');
                }
            }
        };

        // Check the anchor on page load
        openAccordion();

        // Check the anchor on hash change
        window.addEventListener('hashchange', openAccordion);

        if (title) {
            title.addEventListener('click', () => {
                // Close all other accordions
                accordions.forEach((acc) => {
                    if (acc !== accordion) {
                        acc.querySelector('.accordion-content').classList.remove('open');
                        const accTitle = acc.querySelector('.accordion-title');
                        if (accTitle) {
                            accTitle.classList.remove('active');
                        }
                    }
                });
                // Toggle the clicked accordion
                content.classList.toggle('open');
                title.classList.toggle('active');
            });
        }
    });
});
